import React, { useState } from 'react'
import './../styles/components/tip.css';

function Tip({ text, link, href }) {
    return (
        <div className="component tip">
            <img src="/assets/icons/bulb.svg" alt="" />
            <p>{text} <a href={href}>{link}</a></p>
        </div>
    )
}

export default Tip